import React, {useState} from 'react';
import '../style/footer.css';

export default function Footer() {
    const [deployFooter, setDeployFooter] = useState(false);
    return (
        <div
            className="footer_container"
            onMouseEnter={() => setDeployFooter(true)}
            style={{
                height: deployFooter ? 'var(--footerHeight)' : '80px',
                width: deployFooter ? '100vw' : '50px',
                background:
                    deployFooter
                        ? 'linear-gradient(rgba(255, 255, 255, 0.9), grey)'
                        : 'rgba(255, 255, 255, 0.5)',
            }}>
            {!deployFooter && (
                <img src={process.env.PUBLIC_URL + '/icons/footer_icon.png'} width="40" height="70" style={{paddingTop: '8px'}} alt="deploy footer"/>
            )}
            {deployFooter && (
                <div className="footer_content">
                    <div className="close_footer" onClick={() => setDeployFooter(false)}>
                    <img
                        className="add_comment"
                        src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                        width="50"
                        height="50"
                        alt="go back" />
                    </div>
                    <div className="footer_part_row">
                        <div className="media_link" style={{paddingLeft: '10px'}}>
                            <img src={process.env.PUBLIC_URL + '/icons/facebook_icon.png'} width="50" height="50" alt="facebook" />
                        </div>
                        <div className="media_link">
                            <img src={process.env.PUBLIC_URL + '/icons/twitter_icon.png'} width="50" height="50" alt="facebook" />
                        </div>
                        <div className="media_link" style={{paddingRight: '10px'}}>
                            <img src={process.env.PUBLIC_URL + '/icons/instagram_icon.png'} width="50" height="50" alt="facebook" />
                        </div>
                    </div>
                    <div className="footer_part_column">
                        <div className="footer_part_column_div">
                            <div>
                                <a href="" className="footerLink">Conditions générale</a>
                            </div>
                            <div>
                                <a href="" className="footerLink">Mentions légales</a>
                            </div>
                            <div>
                                <span className="footerLink">Phone : </span>
                                <a href="" className="footerLink">0666123456</a>
                            </div>
                            <div>
                                <span className="footerLink">Email : </span>
                                <a href="" className="footerLink">administrator@admin.com</a>
                            </div>
                            <div>
                                <a 
                                    className="footerLink"
                                    href="https://www.pascalcosta.fr/#/contact"
                                    target="_blank"
                                    rel="noreferrer">Contact the webmaster</a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
